import 'tom-select/dist/css/tom-select.css';
import TomSelect from 'tom-select';

export function initTomSelect(): void {
    document.querySelectorAll<HTMLSelectElement>('form select').forEach((select) => {
        new TomSelect(select, {
            create: false,
            allowEmptyOption: true,
            maxOptions: undefined,
            dropdownParent: 'body',
            onInitialize(this: TomSelect) {
                this.control_input.setAttribute('readonly', 'true');
            },
            onType(this: TomSelect) {
                this.setTextboxValue('');
            },
        });
    });
}
